import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

export type ValueType = string | null | boolean | number

const coerceValueFromType = (field: Field | CustomField, value: ValueType): ValueType => {
  switch (field.attributes.field_type) {
    case FieldTypes.cents:
    case FieldTypes.money:
      return value ? +value / 100.0 : 0

    default:
      return value
  }
}

export default coerceValueFromType
